import React from "react";

import { ActivityStatusNotification } from "@views/my-work/components/course/activity-status-notification";

import "./ooh-activity-view.scss";

const OohContent = ({ oohLaunchParameters, data }) => {
  let oohLaunchUrl = `${data.hostedContentPath}?slxapi=${encodeURIComponent(
    JSON.stringify(oohLaunchParameters)
  )}`;

  return (
    <div className="activity-player-ooh-content">
      <div className="activity-player-ooh-content-status">
        <ActivityStatusNotification
          status={data?.isComplete ? data?.masteryStatus : ""}
          contentType={data?.contentType}
          masteryScore={data?.masteryScore}
          latestTimestamp={data?.latestTimestamp}
          isComplete={data?.isComplete}
        />
      </div>
      <div className="iframe-container">
        <iframe src={oohLaunchUrl}></iframe>
      </div>
    </div>
  );
};

export default OohContent;
